import { render, staticRenderFns } from "./RedSocials.vue?vue&type=template&id=0775ff5f&scoped=true&"
import script from "./RedSocials.vue?vue&type=script&lang=js&"
export * from "./RedSocials.vue?vue&type=script&lang=js&"
import style0 from "./RedSocials.vue?vue&type=style&index=0&id=0775ff5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775ff5f",
  null
  
)

export default component.exports